import { BLOCK } from "../../../types";
import { StructureBrush } from "../brush";
import type { StructureBuilder } from "../types";

export const buildMesaMine: StructureBuilder = (world, spot) => {
    const brush = new StructureBrush(world, spot);
    const outerPosts: [number, number][] = [
        [1, 1],
        [5, 1],
        [1, 5],
        [5, 5],
    ];

    for (const [dx, dz] of outerPosts) {
        brush.column(dx, dz, 0, 3, BLOCK.StructureLog);
    }
    brush.lineX(1, 5, 3, 1, BLOCK.StructureLog);
    brush.lineX(1, 5, 3, 5, BLOCK.StructureLog);
    brush.lineZ(1, 3, 1, 5, BLOCK.StructureLog);
    brush.lineZ(5, 3, 1, 5, BLOCK.StructureLog);

    const innerPosts: [number, number][] = [
        [2, 2],
        [4, 2],
        [2, 4],
        [4, 4],
    ];
    for (const [dx, dz] of innerPosts) {
        brush.column(dx, dz, 4, 6, BLOCK.StructureLog);
    }
    brush.lineX(2, 4, 7, 2, BLOCK.DarkPlanks);
    brush.lineX(2, 4, 7, 4, BLOCK.DarkPlanks);
    brush.lineZ(2, 7, 2, 4, BLOCK.DarkPlanks);
    brush.lineZ(4, 7, 2, 4, BLOCK.DarkPlanks);
    brush.layer(2, 4, 2, 4, 0, BLOCK.DarkPlanks);

    brush.block(3, 6, 3, BLOCK.StructureLog);
    brush.block(3, 5, 3, BLOCK.Glowstone);
};
